import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { EXTERNAL_LINKS } from "routes/paths";
import { getCookie, setCookie } from "services/cookies";
import { COOKIES } from "constants/cookies";

export const SardineProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const initSardine = () => {
    if (!isLoaded) {
      let sessionCookie = getCookie(COOKIES.X_SESSION);

      if (!sessionCookie.length) {
        sessionCookie = uuidv4();
        setCookie({ name: COOKIES.X_SESSION, value: sessionCookie, days: 28 });
      }

      const clientId = getCookie(COOKIES.SARDINE_CLIENT_ID);
      const sessionKey = sessionCookie;

      if (clientId) {
        const isSandbox = !(window.location.host === "gcx.raise.com");
        const loader = document.createElement("script");
        loader.async = true;
        loader.src = EXTERNAL_LINKS.RAISE_RISK_SDK;
        loader.onload = () => {
          window._Raise.initialize({ clientId, sessionKey, isSandbox });
        };
        const script = document.getElementsByTagName("script")[0];
        script.parentNode.insertBefore(loader, script);
        setIsLoaded(true);
      }
    }
  };

  useEffect(initSardine, [isLoaded]);

  return <>{children}</>;
};
